var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMana17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-342.01 1.0719)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6 0 0 6 1602 628.94)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -160,
    cy: -55.002,
    r: 50,
    fill: "#cac5c0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m544.27 113.85v295.84c0 35.274 14.58 52.884 43.71 52.884h6.888v19.932h-157.13v-19.932h10.734c29.628 0 44.46-17.616 44.46-52.884v-193.91c0-35.742-12.774-53.646-38.322-53.646h-15.354v-19.92h6.138c30.654 0 58.266-9.456 82.782-28.362l16.092-7e-3zm196.24 370.95h-53.67v-6.12c0-34.242 10.734-77.412 32.178-129.52 32.718-77.694 62.88-137.47 90.444-179.36l3.096-5.37h-125.72c-18.396 0-32.322 3.834-41.766 11.472-9.444 7.6741-16.758 20.46-21.87 38.334h-20.67l22.992-101.17h13.806c7.6381 3.588 21.468 5.37 41.388 5.37h165.54v29.13c-6.12 8.694-13.782 22.476-22.992 41.376-17.904 34.77-34.242 75.126-49.056 121.09-21.984 68.49-33.21 126.76-33.702 174.76z",
    fill: "#0d0f0f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana17);
export default __webpack_public_path__ + "static/media/mana17.b1e4cbc1bf068d50352e681c4748f5fa.svg";
export { ForwardRef as ReactComponent };